import { getDealerIdFromSlug } from '../utilities';

export default function withCtxQueryDealerDetail() {
    return (ctx) => {
        ctx.query.dealerId = getDealerIdFromSlug(ctx.query.slug);
    };
}
